import {Component, OnInit} from '@angular/core';
import {FeedbackService} from '../shared/services/feedback.service';
import {PaginationArgs} from '../shared/models/pagination.args';
import {FeedbackWebDto} from '../shared/models/feedback.web.dto';
import {LazyLoadEvent} from 'primeng/api';

@Component({
    selector: 'njoy-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {

    public paginationArgs: PaginationArgs = {pageNumber: 0, pageSize: 10};

    public listFeedback = [];
    public totalRecords = 0;
    public first = 0;
    public row = 0;

    constructor(private feedbackService: FeedbackService) {
    }

    ngOnInit(): void {
        this.row = 10;
        this.paginationArgs = {pageNumber: 0, pageSize: this.row};
        this.getAllFeedback();
    }

    private getAllFeedback() {
        this.feedbackService.findFeebacksByPage(this.paginationArgs).subscribe((data: any) => {
            this.listFeedback = data.content;
            this.listFeedback.forEach((item: FeedbackWebDto) => {
                item.creationDate = new Date(item.creationDate);
            });
            this.totalRecords = data.totalElements;
            this.row = this.paginationArgs.pageSize;
        });
    }

    public onLazyLoad(event: LazyLoadEvent) {
        this.paginationArgs = {pageNumber: event.first / event.rows, pageSize: event.rows};
        this.getAllFeedback();
    }

    public changeStatus(feedback: any) {
        if (feedback.statusFeedBack === 'VALIDATED') {
            feedback.statusFeedBack = 'DELETED';
        } else if (feedback.statusFeedBack === 'PENDING') {
            feedback.statusFeedBack = 'VALIDATED';
        } else {
            feedback.statusFeedBack = 'PENDING';
        }

        this.validateFeedBack(feedback);
    }

    private validateFeedBack(feedback: any) {
        this.feedbackService.validateFeedBack(feedback).subscribe(() => {}, (err: any) => {
            console.log(err);
        });
    }
}
